import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";

import CircleIcon from "@mui/icons-material/Circle";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";

import { Grid, Button, Typography, MenuItem, FormControl, Select, List, FormControlLabel, Checkbox, ListItem, ListItemText, Snackbar } from "@mui/material";

import { getUsersByRoleId, updateUsersAction } from "./Services";
import { joinByKeys, getClassNames } from "./../../Js/Common";

const MoveLearners = (props) => {
  // Hooks
  const classes = useStyles();
  const navigation = useNavigate();

  // const { uid } = useParams();

  // Redux state
  const userInfo = useSelector((state) => state.loggedInUserInfo.userInfo);
  const { paramsdata } = useSelector((state) => state.common);

  // State
  const [allClasses, setAllClasses] = useState([]);
  const [fromClassId, setFromClassId] = useState(null);
  const [toClassId, setToClassId] = useState(null);
  const [userData, setUserData] = useState([]);
  const [selectedUserIds, setSelectedUserIds] = useState([]);
  const [allChecked, setAllChecked] = useState(false);

  const [stateSnackbar, setStateSnackbar] = useState({ open: false, vertical: 'bottom', horizontal: 'center' });
  const { vertical, horizontal, open } = stateSnackbar;
  const [snackbarMessage, setSnackbarMessage] = useState('');

  useEffect(() => {
    const getInitialData = async () => {
      let classData = await getClassNames(userInfo.site_uuid);
      console.log("classData", classData);
      setAllClasses(classData);
      if (classData.length > 0) {
        setFromClassId(classData[0].id);
        fetchUsersByRole(classData[0].id);
      }
    };
    getInitialData();
  }, []);

  const selectUsers = (flg) => {
    let newArr = [];
    if (flg === true) {
      newArr = userData.map(function (obj) {
        return obj.uid;
      });
    }
    setSelectedUserIds(newArr);
  };

  const setUserClass = () => {
    fetchUsersByRole(props.clickOption);
  };

  const fetchUsersByRole = async (selectedClassId = null) => {
    let params = {
      query: {
        $limit: -1,
        role_uid: paramsdata.rolesData.uid,
        site_uuid: userInfo.site_uuid,
        belongs_to: selectedClassId,
        status: true,
      },
    };

    let resUsersData = await getUsersByRoleId(params);
    setUserData(resUsersData.data);
  };

  const setUserSelection = (id) => {
    let newArr = [...selectedUserIds];
    let position = newArr.indexOf(id);
    if (position === -1) {
      newArr.push(id);
    } else {
      newArr.splice(position, 1);
    }
    setSelectedUserIds(newArr);
    if(newArr.length === userData.length){
      setAllChecked(true);
    }else{
      setAllChecked(false);
    }
  };

  const fromClassChange = (event) => {
    setSelectedUserIds([]);
    setAllChecked(false);
    setFromClassId(event.target.value);
    fetchUsersByRole(event.target.value);
  };

  const toClassChange = (event) => {
    setToClassId(event.target.value);
  };

  const selectAllChange = (e) => {
    setAllChecked(e.target.checked);
    if(e.target.checked === true){
      let newArr = userData.map(function (obj) {
        return obj.uid;
      });
      setSelectedUserIds(newArr);
    }
    else{
      setSelectedUserIds([]);
    }
  };

  const moveLearnersToClass = async() => {
    if(selectedUserIds.length == 0 ){
      setSnackbarMessage('Please select learner');
      setStateSnackbar({ ...stateSnackbar, open: true });
      return;
    }
    if(toClassId === '' || toClassId == null){
      setSnackbarMessage('Please select the class to move');
      setStateSnackbar({ ...stateSnackbar, open: true });
      return;
    }
    if(fromClassId == toClassId){
      setSnackbarMessage('Please select different class');
      setStateSnackbar({ ...stateSnackbar, open: true });
      return;
    }
    let data = {};
    data.belongs_to = toClassId;
    data.is_synced = false;
    let params = {
      query:{
        uid: selectedUserIds,
        site_uuid: userInfo.site_uuid
      }
    };
    let response = await updateUsersAction(null, data, params);
    console.log("respomse======",response);

    setSelectedUserIds([]);
    setToClassId('');
    setAllChecked(false);
    fetchUsersByRole(fromClassId);
  };

  const handleClose = () => {
    setStateSnackbar({ ...stateSnackbar, open: false });
  };

  return (
    <Grid
      container
      spacing={1}
      marginTop={2}
       
      sx={{
        flexDirection: "row",
        justifyContent: "space-around",
        alignItems: "center",
        px: 10,
      }}
    >
      <Grid xs={12} sx={{ textAlign: "right", pr: 3 }}>
        <Button
          sx={{
            color: "#FFFFFF",
            backgroundColor: "#DB8829",
            fontWeight: "600",
            borderRadius: 10,
            px: 2,
           '@media (min-width: 1636px)': {fontSize: '1.2rem',px: 2}
          }}
          onClick={moveLearnersToClass}
        >
          Move
        </Button>
      </Grid>
      <Grid item xs={5} sx={{ pb: 0.5 }}>
        {allClasses && allClasses.length > 0 && (
          <>
            <FormControl sx={{ m: 1 }} size="small" fullWidth>
              <Typography
                sx={{
                  color: "primary.main",
                  fontSize: "1.1rem",
                  fontWeight: "600",'@media (min-width: 1636px)': {fontSize: '1.4rem'}
                }}
              >
                From Class
              </Typography>
              <Select
                width="100%"
                value={fromClassId}
                onChange={fromClassChange}
                sx={{ borderRadius: 10, backgroundColor: "#CCCCCC",'@media (min-width: 1636px)': {fontSize: '1.4rem'} }}
              >
                {allClasses &&
                  allClasses.map((obj, ind) => {
                    return (
                      <MenuItem key={`${ind}_fromclass`} value={obj.id} sx={{'@media (min-width: 1636px)': {fontSize: '1.4rem'}}}>
                        {obj.value}
                      </MenuItem>
                    );
                  })}
              </Select>
            </FormControl>
          </>
        )}
      </Grid>
      <Grid item xs={5} sx={{ pb: 0.5 }}>
        {allClasses && allClasses.length > 0 && (
          <>
            <FormControl sx={{ m: 1 }} size="small" fullWidth>
              <Typography
                sx={{
                  color: "primary.main",
                  fontSize: "1.1rem",
                  fontWeight: "600",'@media (min-width: 1636px)': {fontSize: '1.4rem'}
                }}
              >
                To Class
              </Typography>
              <Select
                width="100%"
                value={toClassId}
                onChange={toClassChange}
                sx={{ borderRadius: 10, backgroundColor: "#CCCCCC",'@media (min-width: 1636px)': {fontSize: '1.4rem'} }}
              >
                {allClasses &&
                  allClasses.map((obj, ind) => {
                    return (
                      <MenuItem key={`${ind}_toclass`} value={obj.id} sx={{'@media (min-width: 1636px)': {fontSize: '1.4rem'}}}>
                        {obj.value}
                      </MenuItem>
                    );
                  })}
              </Select>
            </FormControl>
          </>
        )}
      </Grid>
      <Grid
        xs={12}
        sx={{ borderTop: 2, borderColor: "#CCCCCC", mt: 1, mx: 5, ml: 8 }}
      ></Grid>
      {userData && userData.length > 0 ? (
        <>
        <Grid item
          xs={12}
           
          sx={{
            flexDirection: "row",
            justifyContent: "flex-start",
            overflow: "auto",
            mx: 6,
            my: 0,
            ml: 7,
          }}>
        <FormControlLabel
          sx={{ pl: 3 }}
          style={{
            fontSize: "0.9rem",
            fontWeight: "500",
            color: "#DB8829",
          }}
          control={
            <Checkbox
              icon={<RadioButtonUncheckedIcon />}
              checkedIcon={<CircleIcon />}
              checked={allChecked}
              onClick={selectAllChange}
            />
          }
          label={<Typography sx={{fontSize: '0.9rem',fontWeight: '500','@media (min-width: 1636px)': {fontSize: '1.4rem'}}}>Select All</Typography>}
        ></FormControlLabel>
        </Grid>
        <Grid
          item
          xs={12}
           
          sx={{
            flexDirection: "row",
            justifyContent: "flex-start",
            height: "60vh",
            overflow: "auto",
            mx: 6,
            my: 0,
            ml: 9,
          }}
        >
          {userData.map((objUser, index) => {
            return (
              <List dense sx={{ p: 0, m: 0 }}>
                <ListItem sx={{ p: 0 }}>
                  <Checkbox
                    icon={<RadioButtonUncheckedIcon />}
                    checkedIcon={<CircleIcon />}
                    value={objUser.uid}
                    checked={selectedUserIds.indexOf(objUser.uid) != -1}
                    onClick={() => {
                      setUserSelection(objUser.uid);
                    }}
                  />
                  <ListItemText
                    sx={{ m: 0, px: 0, py: 0.3 }}
                    primary={
                      <Typography
                        sx={{
                          fontSize: "0.9rem",
                          fontWeight: "500",
                          color: "#DB8829",'@media (min-width: 1636px)': {fontSize: '1.2rem'}
                        }}
                      >
                        {joinByKeys(
                          objUser.name,
                          ["firstname", "lastname"],
                          " "
                        )}
                      </Typography>
                    }
                  />
                </ListItem>
              </List>
            );
          })}
        </Grid>
        </>
      ) : (
        <Typography>No user available</Typography>
      )}
      <Snackbar
        anchorOrigin={{ vertical, horizontal }}
        autoHideDuration={6000}
        open={open}
        onClose={handleClose}
        message={snackbarMessage}
        key={vertical + horizontal}
        ContentProps={{
              classes: {
              root: classes.root
              }
        }}
        sx = {{top: {xs:90,sm:0}}}
      />
    </Grid>
  );
};
const useStyles = makeStyles({
  scrollBar: {
    "&::-webkit-scrollbar": {
      width: "0.6em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
  },
});

export default MoveLearners;
